// libs
import React, { memo } from "react";
import styled from "@emotion/styled";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

// components
import Message from "./components/Message";
import Suggestion from "./components/Suggestion";

// constants
import { TEXTS } from "shared/components/HeaderSearch/constants";

// styles
const AutoSuggestContainer = styled.div`
    padding: 10px 0 0;
`;

// defs
import { IAutoSuggestResponse, ISuggestion } from "shared/components/HeaderSearch/types";
interface IAutoSuggestProps {
    data: IAutoSuggestResponse;
    term: string;
}

const SUCCESS_MESSAGE = "success";

function AutoSuggest({ data, term }: IAutoSuggestProps) {
    const suggestions = get(data, "response.suggestions", []);

    if (get(data, "message", "").toLowerCase() !== SUCCESS_MESSAGE) {
        return <Message isError>{TEXTS.OOPS}</Message>;
    }

    if (isEmpty(suggestions)) {
        return <Message>{`${TEXTS.NO_RESULTS_FOUND}"${term}"`}</Message>;
    }

    return (
        <AutoSuggestContainer>
            {suggestions.map((suggestion: ISuggestion, idx: number) => (
                <Suggestion
                    key={idx}
                    url={suggestion.url}
                    title={suggestion.suggestionWord}
                    term={term}
                    type={suggestion.type}
                    clickIndex={idx + 1}
                />
            ))}
        </AutoSuggestContainer>
    );
}

export default memo(AutoSuggest);
